import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Heart, ShoppingBag } from 'lucide-react';

// This would typically come from your API
const allProducts = [
  ...Array.from({ length: 20 }, (_, i) => ({
    id: i + 1,
    name: `${['Classic', 'Premium', 'Sport', 'Casual', 'Luxury'][i % 5]} ${
      ['Sneaker', 'Boot', 'Loafer', 'Running Shoe', 'Sandal'][i % 5]
    }`,
    price: Math.floor(Math.random() * (200 - 50) + 50),
    category: ['Men', 'Women', 'Sport', 'Casual'][i % 4],
    image: `https://images.unsplash.com/photo-${1542291026 + i}-7eec264c27ff?auto=format&fit=crop&q=80&w=500`,
  })),
];

export default function SearchResults() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [filteredProducts, setFilteredProducts] = useState(allProducts);

  useEffect(() => {
    const filtered = allProducts.filter((product) =>
      product.name.toLowerCase().includes(query.toLowerCase()) ||
      product.category.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredProducts(filtered);
  }, [query]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold mb-2">
          Search Results for "{query}"
        </h1>
        <p className="text-gray-600">
          Found {filteredProducts.length} products
        </p>
      </div>

      {filteredProducts.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-xl text-gray-600">No products found matching your search.</p>
          <p className="mt-2 text-gray-500">Try adjusting your search terms or browse our categories.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {filteredProducts.map((product) => (
            <div key={product.id} className="bg-white rounded-lg shadow-md overflow-hidden group">
              <div className="relative">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-48 sm:h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <button className="absolute top-2 right-2 p-2 rounded-full bg-white/80 backdrop-blur-sm text-gray-600 hover:text-red-500 transition-colors">
                  <Heart className="h-4 w-4 sm:h-5 sm:w-5" />
                </button>
              </div>
              <div className="p-4">
                <h3 className="text-sm sm:text-base font-medium text-gray-900">{product.name}</h3>
                <p className="text-xs sm:text-sm text-gray-500">{product.category}</p>
                <div className="mt-2 flex justify-between items-center">
                  <span className="text-sm sm:text-base font-bold text-gray-900">${product.price}</span>
                  <button className="flex items-center gap-1 bg-black text-white px-2 sm:px-3 py-1 sm:py-1.5 rounded-full text-xs sm:text-sm hover:bg-gray-800 transition-colors">
                    <ShoppingBag className="h-3 w-3 sm:h-4 sm:w-4" />
                    <span className="hidden sm:inline">Add</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}